import { Languages } from "src/common/descriptions/types";
import { ServicesDescriptions } from "./types";

const DescriptionsEnUs: ServicesDescriptions = {
    TITLE: "Services",
    TABLE: {
        ACTION_BUTTON: "Create Service",
        SEARCH_PLACEHOLDER: "Search Service",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        NAME: "Name",
        PRICE: "Price",
        IS_MONTHLY: "Is monthly",
        STATUS: "Status",
        ACTIONS: "Actions",
        CATEGORY: "Category",
    },
}

const DescriptionsEsUs: ServicesDescriptions = {
    TITLE: "Servicios",
    TABLE: {
        ACTION_BUTTON: "Crear Servicio",
        SEARCH_PLACEHOLDER: "Buscar Servicio",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        NAME: "Nombre",
        PRICE: "Precio",
        IS_MONTHLY: "Es Mensual",
        STATUS: "Estado",
        ACTIONS: "Acciones",
        CATEGORY: "Categoría",
    },
}

export const servicessDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}